import { useCallback, useState } from 'react';
import clsx from 'clsx';
import { RoutedLink, Title } from '@/components';
import { Container, BreadCrumbs } from '@/containers';
import Icon from '@/assets/icons';
import { useWindowSize } from '@/hooks';
import styles from './CatalogSeoPage.module.scss';

const CatalogSeoPage = ({ tree }) => {
	const { isMobile } = useWindowSize();

	const [openedAll, setOpenedAll] = useState({});
	const [openedHeadCategoty, setOpenedHeadCategoty] = useState({});

	const getColor = (viewType, color) => {
		if (viewType === 'sale') {
			return '#EA5656';
		}

		if (viewType === 'premium') {
			return '#74849C';
		}

		return color;
	};

	const allSectionsButton = useCallback((length, opened, id) => {
		return length > 5 ? (
			<div>
				<div
					className={styles.sectionButton}
					onClick={() => {
						setOpenedAll(prevState => {
							return {
								...prevState,
								[id]: !opened,
							};
						});
					}}
				>
					{opened ? 'Свернуть разделы' : 'Все разделы'}
				</div>
			</div>
		) : null;
	});

	const getBlockTitle = useCallback(
		({ color, path, name, id, view_type }, opened, length) => {
			if (isMobile) {
				return (
					<span className={styles.subCategoryTitle} style={{ color: getColor(view_type, color) }}>
						<RoutedLink to={path}>{name}</RoutedLink>
						{length > 0 && (
							<Icon
								className={styles.icon}
								name={opened ? 'arrow-up' : 'arrow-down'}
								onClick={() => {
									setOpenedHeadCategoty(prevState => {
										return {
											...prevState,
											[id]: !opened,
										};
									});
								}}
							/>
						)}
					</span>
				);
			}

			return (
				<span className={styles.subCategoryTitle} style={{ color: getColor(view_type, color) }}>
					<RoutedLink to={path}>{name}</RoutedLink>
				</span>
			);
		},
		[isMobile],
	);

	const getBlock = useCallback(
		node => {
			const opened = typeof openedAll[node.id] === 'boolean' ? openedAll[node.id] : false;
			const openedCategoty =
				typeof openedHeadCategoty[node.id] === 'boolean' ? openedHeadCategoty[node.id] : false;
			const className = !openedCategoty ? styles.mobileHidden : styles.subCategoryBlock;

			return (
				<div className={styles.block} key={node.id}>
					{getBlockTitle(node, openedCategoty, node.children.length)}
					{node.children.length > 0 && (
						<div className={className}>
							{node.children.map(({ path, name, color, id, view_type }, index) => {
								return (
									<div
										className={clsx(
											styles.subCategory,
											index > 4 && !opened && styles.subCategoryHidden,
										)}
										style={{ color: getColor(view_type, color) }}
										key={id}
									>
										<RoutedLink to={path}>{name}</RoutedLink>
									</div>
								);
							})}
							{allSectionsButton(node.children.length, opened, node.id)}
						</div>
					)}
				</div>
			);
		},
		[openedAll, openedHeadCategoty, getBlockTitle, allSectionsButton],
	);

	const breadcrumbs = [
		{
			slug: '/',
			name: 'Каталог',
		},
	];

	return (
		<Container>
			<div className={styles.breadCrumbs}>
				<BreadCrumbs breadcrumbs={breadcrumbs} />
			</div>

			<Title component='h1' className={styles.generalTitle}>
				Каталог
			</Title>
			{tree?.map(node => {
				return (
					<div className={styles.container} key={node.id}>
						<Title
							component='h2'
							className={styles.headCategory}
							style={{ color: getColor(node.view_type, node.color) }}
						>
							<RoutedLink to={node.path}>{node.name}</RoutedLink>
						</Title>
						<div className={styles.wrapper}>
							{node.children.map(nodeCategory => {
								return getBlock(nodeCategory);
							})}
						</div>
					</div>
				);
			})}
		</Container>
	);
};

export default CatalogSeoPage;
